import { render, staticRenderFns } from "./Cloth.vue?vue&type=template&id=41269d80&scoped=true&"
import script from "./Cloth.vue?vue&type=script&lang=js&"
export * from "./Cloth.vue?vue&type=script&lang=js&"
import style0 from "./Cloth.vue?vue&type=style&index=0&id=41269d80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41269d80",
  null
  
)

export default component.exports